// src/components/charts/selectors/AnalysisTypeSelector.tsx
import React, { useMemo } from 'react';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';

interface AnalysisTypeSelectorProps {
    items: any[];
    selectedAnalysisType: string;
    setSelectedAnalysisType: (value: string) => void;
}

const AnalysisTypeSelector: React.FC<AnalysisTypeSelectorProps> = ({ items, selectedAnalysisType, setSelectedAnalysisType }) => {
    const analysisTypeOptions = useMemo(() => {
        const types = new Set<string>();
        items.forEach((item) => {
            item.DATA.forEach((row: { ANALYSIS_TYPE: string; }) => {
                if (row.ANALYSIS_TYPE) types.add(row.ANALYSIS_TYPE);
            });
        });
        const sortedTypes = Array.from(types).sort((a, b) => a.localeCompare(b));
        return ['All', ...sortedTypes];
    }, [items]);

    const handleChange = (event: SelectChangeEvent<string>) => {
        setSelectedAnalysisType(event.target.value);
    };

    return (
        <FormControl sx={{ minWidth: 200 }}>
            <InputLabel>Analysis Type</InputLabel>
            <Select
                value={selectedAnalysisType}
                onChange={handleChange}
                label="Analysis Type"
                size="small"
            >
                {analysisTypeOptions.map(option => (
                    <MenuItem key={option} value={option}>
                        {option}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default AnalysisTypeSelector;
